import React from "react";
import { connect } from "react-redux";
import { ReduxDispatch, ReduxState } from "ducks/reducers";
import {
    SetHeader,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
    ShowLogo,
} from "ducks/common";
import { fetchSubjectCategories, getCategories } from "ducks/subjectCategories";
import { SubjectCategoryDto } from "util/DTOs/SubjectCategoryDtos";
import {
    SetActionButtonAndShow,
    ResetActionButtonClicked,
    SetShowActionButton,
    actionButtonClicked,
    SetActionButtonDisabled,
    actionButtonDisabled,
} from "ducks/actionbutton";
import { isInvalid, submit } from "redux-form";
import NewThreadForm, {
    NewThreadFormData,
} from "views/messages/components/NewThreadForm";
import { RouterProps } from "react-router";
import logger from "util/logger";
import { createNewThread } from "../../ducks/messages";
import {
    CreateMessageThreadDto,
    MessageSender,
} from "../../util/DTOs/MessageDtos";

interface INewThreadPageProps {}

interface INewThreadPageReduxProps {
    actionButtonClicked: boolean;
    actionButtonDisabled: boolean;
    formInvalid: boolean;
    subjectCategories: SubjectCategoryDto[];
}

interface INewThreadPageDispatchProps {
    setHeader: (value: string) => void;
    setBackButton: (route: string) => void;
    postNewThread: (
        category: string,
        title: string,
        content: string
    ) => Promise<void>;
    submitNewThread: () => void;
    hideBackButton: () => void;
    setShowActionButton: (show: boolean) => void;
    setActionButton: (text: string) => void;
    resetActionButtonClick: () => void;
    disableActionButton: (disabled: boolean) => void;
    showLogo: (show: boolean) => void;
    getSubjectCategories: () => void;
}

interface INewThreadPageState {}

type NewThreadPageProps = INewThreadPageProps &
    INewThreadPageDispatchProps &
    INewThreadPageReduxProps &
    RouterProps;

class NewThreadPage extends React.Component<
    NewThreadPageProps,
    INewThreadPageState
> {
    constructor(props: NewThreadPageProps) {
        super(props);
    }

    componentDidMount() {
        this.props.showLogo(false);
        this.props.setHeader("Uusi kysymys");
        this.props.setActionButton("Lähetä");
        this.props.setBackButton("/messages");
        this.props.getSubjectCategories();
    }

    componentWillReceiveProps(nextProps: NewThreadPageProps) {
        if (this.props.formInvalid !== nextProps.formInvalid) {
            if (nextProps.formInvalid && !nextProps.actionButtonDisabled) {
                this.props.disableActionButton(true);
            } else if (
                !nextProps.formInvalid &&
                nextProps.actionButtonDisabled
            ) {
                this.props.disableActionButton(false);
            }
        }

        if (nextProps.actionButtonClicked === true) {
            this.props.submitNewThread();
            this.props.resetActionButtonClick();
        }
    }

    componentWillUnmount() {
        this.props.setHeader("");
        this.props.hideBackButton();
        this.props.showLogo(true);
        this.props.setShowActionButton(false);
    }

    sendNewThread = (data: NewThreadFormData) => {
        const { subjectCategories } = this.props;
        const id = parseInt(data.subjectCategoryId, 10);
        const category = subjectCategories.find((it) => it.id === id);
        const name = category !== undefined ? category.name : "";

        this.props
            .postNewThread(name, data.subject, data.body)
            .then(() => {
                this.props.resetActionButtonClick();
                this.props.history.replace("/messages");
            })
            .catch((error) => {
                logger.error(error);
                this.props.resetActionButtonClick();
            });
    };

    submitFail = () => {
        this.props.resetActionButtonClick();
    };

    render() {
        return (
            <div className="page-container">
                <NewThreadForm
                    form={"newThreadForm"}
                    initialValues={{}}
                    onSubmit={this.sendNewThread}
                    onSubmitFail={this.submitFail}
                    subjectCategories={this.props.subjectCategories}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): INewThreadPageReduxProps => {
    const disabled = actionButtonDisabled(state);

    return {
        actionButtonClicked: actionButtonClicked(state),
        actionButtonDisabled: disabled,
        formInvalid: isInvalid("newThreadForm")(state),
        subjectCategories: getCategories(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): INewThreadPageDispatchProps => {
    return {
        setHeader: (value: string) => {
            dispatch(SetHeader(value));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        submitNewThread: () => {
            dispatch(submit("newThreadForm"));
        },
        postNewThread: (category: string, title: string, content: string) => {
            return dispatch(
                createNewThread({
                    category: category,
                    title: title,
                    content: content,
                    sender: MessageSender.Customer,
                } as CreateMessageThreadDto)
            );
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        setShowActionButton: (show: boolean) => {
            dispatch(SetShowActionButton(show));
        },
        setActionButton: (text: string) => {
            dispatch(SetActionButtonAndShow({ text }));
        },
        resetActionButtonClick: () => {
            dispatch(ResetActionButtonClicked());
        },
        showLogo: (show: boolean) => {
            dispatch(ShowLogo(show));
        },
        disableActionButton: (disabled: boolean) => {
            dispatch(SetActionButtonDisabled(disabled));
        },
        getSubjectCategories: () => {
            dispatch(fetchSubjectCategories());
        },
    };
};

export default connect<
    INewThreadPageReduxProps,
    INewThreadPageDispatchProps,
    INewThreadPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(NewThreadPage);



// WEBPACK FOOTER //
// ./src/views/messages/NewThreadPage.tsx